const WHATSAPP_NUMBER = "56975578118";

const messages = {
  es: `Hola, vi a RC7 y me gustaría conversar sobre una solución para mi negocio. ¿Me pueden orientar?`,
  
  en: `Hola, vi a RC7 y me gustaría conversar sobre una solución para mi negocio. ¿Me pueden orientar?`
};

export const getWhatsAppLink = (language) => {
  const message = messages[language] || messages.es;
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
};
